import React from 'react'
import { Link } from 'react-router-dom'
import ReminderBadge from './ReminderBadge'

function VehicleAvatar({ vehicle, size = 40 }) {
  const initials = (vehicle.model || '').slice(0, 2).toUpperCase()

  if (vehicle.photo_url) {
    return (
      <img
        src={vehicle.photo_url}
        alt={vehicle.display_name}
        className="object-cover flex-shrink-0"
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <div
      className="bg-ink text-paper flex items-center justify-center font-extrabold tracking-wide flex-shrink-0"
      style={{ width: size, height: size, fontSize: size * 0.36 }}
    >
      {initials}
    </div>
  )
}

export { VehicleAvatar }

function Stat({ label, value }) {
  return (
    <div className="min-w-0">
      <p className="text-[11px] font-bold uppercase tracking-widest text-muted">{label}</p>
      <p className="font-mono text-sm font-medium text-ink truncate">{value}</p>
    </div>
  )
}

export default function VehicleCard({ vehicle }) {
  return (
    <Link
      to={`/vehicles/${vehicle.id}`}
      className="block bg-surface border-[1.5px] border-ink p-4 sm:p-5 hover:bg-white transition-colors"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <VehicleAvatar vehicle={vehicle} size={48} />
          <div className="min-w-0">
            <h3 className="text-lg font-extrabold text-ink leading-tight">{vehicle.display_name}</h3>
            {vehicle.vin && (
              <p className="text-xs text-muted mt-0.5 font-mono truncate">{vehicle.vin}</p>
            )}
          </div>
        </div>
        {vehicle.has_overdue && <ReminderBadge />}
      </div>
      <div className="mt-4 pt-3 border-t border-line grid grid-cols-3 gap-3">
        <Stat
          label={vehicle.meter_label === 'hrs' ? 'Hours' : 'Odometer'}
          value={vehicle.current_meter ? `${vehicle.current_meter.toLocaleString()} ${vehicle.meter_label || 'mi'}` : '-'}
        />
        <Stat label="Records" value={vehicle.maintenance_count} />
        <Stat
          label="Spent"
          value={`$${vehicle.total_maintenance_cost?.toLocaleString(undefined, { minimumFractionDigits: 2 }) || '0.00'}`}
        />
      </div>
    </Link>
  )
}
